import React from 'react';
import { Breadcrumbs } from '../../../AbstractElements';
import { Container, Row } from 'reactstrap';
import DetailedSidebar from './DetailedSidebar';
import MainCard from './MainCard';

const KnowledgeDetailContain = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Knowledgebase' parent='Knowledgebase' title='Knowledgebase Details' />
      <Row>
        <DetailedSidebar />
        <MainCard />
      </Row>
    </Container>
  );
};
export default KnowledgeDetailContain;
